function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import BlockQuote from "../molecules/BlockQuote";
import CtaShape from "../molecules/CtaShape";
import HubspotForm from "../molecules/HubspotForm";
import LogoBanner from "../molecules/LogoBanner";
import Video from "../molecules/Video";
import Accordion from "./Accordion";
import AlertBox from "./AlertBox";
import AngleTeaserBlock from "./AngleTeaserBlock";
import AutoDownload from "./AutoDownload";
import BenefitsTabs from "./BenefitsTabs";
import ContentWithImage from "./ContentWithImage";
import CtaBanner from "./CtaBanner";
import CtaSlider from "./CtaSlider";
import CustomerCta from "./CustomerCta";
import CustomerSolutions from "./CustomerSolutions";
import DownloadsTable from "./DownloadsTable";
import EventSpeakers from "./EventSpeakers";
import FeaturedResources from "./FeaturedResources";
import FooterBanner from "./FooterBanner";
import FourColBlocks from "./FourColBlocks";
import FullQuote from "./FullQuote";
import FullWidth from "./FullWidth";
import LifecycleDiagram from "./LifecycleDiagram";
import LogosWithText from "./LogosWithText";
import MetricContent from "./MetricContent";
import { BlockImage } from "./PageContent/BlockImage";
import { BlockIntro } from "./PageContent/BlockIntro";
import { BlockSolution } from "./PageContent/BlockSolution";
import BlockTable from "./PageContent/BlockTable";
import { BlockText } from "./PageContent/BlockText";
import PreviousDownloadsTable from "./PreviousDownloadsTable";
import PreviousVersions from "./PreviousVersions";
import PricingHeader from "./PricingHeader";
import PricingTable from "./PricingTable";
import ProcessTabs from "./ProcessTabs";
import Slideshow from "./Slideshow";
import SoftwareGraphic from "./SoftwareGraphic";
import TabbedContent from "./TabbedContent";
import TabbedInformation from "./TabbedInformation";
import TeamTabs from "./TeamTabs";
import TeaserGrid from "./TeaserGrid";
import TextImageBlock from "./TextImageBlock";
import TextWithBg from "./TextWithBg";
import TextWithStat from "./TextWithStat";
import ThreeColShape from "./ThreeColShape";
import TwoColAngleBlock from "./TwoColAngleBlock";
import TwoColIframe from "./TwoColIframe";
import TwoColInfo from "./TwoColInfo";
import TwoColList from "./TwoColList";
import TwoColMedia from "./TwoColMedia";
import TwoColVideo from "./TwoColVideo";
export function PageContent(props) {
    var _props_page, _props_page_content;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, props.page && ((_props_page = props.page) === null || _props_page === void 0 ? void 0 : (_props_page_content = _props_page.content) === null || _props_page_content === void 0 ? void 0 : _props_page_content.map(function(block, index) {
        if ((block === null || block === void 0 ? void 0 : block.__typename) === "BlockTextWithMetrics") {
            var _block_statistic, _block_statistic1;
            block.statistic = (_block_statistic = block.statistic) === null || _block_statistic === void 0 ? void 0 : _block_statistic.filter(function(stat) {
                return !!stat && !!stat.statNumber;
            });
            if (!(block === null || block === void 0 ? void 0 : (_block_statistic1 = block.statistic) === null || _block_statistic1 === void 0 ? void 0 : _block_statistic1.length)) {
                block.statistic = undefined;
            }
        }
        switch(block === null || block === void 0 ? void 0 : block.__typename){
            case "LogoBanner":
                return /*#__PURE__*/ React.createElement(LogoBanner, _object_spread({
                    key: index
                }, block));
            case "BlockImage":
                return /*#__PURE__*/ React.createElement("div", {
                    className: "page-container"
                }, /*#__PURE__*/ React.createElement(BlockImage, _object_spread({
                    key: index
                }, block)));
            case "BlockHeadingWithText":
                return /*#__PURE__*/ React.createElement(TextWithBg, {
                    key: index,
                    markup: block.content.map(function(item) {
                        return "<h2>".concat(item === null || item === void 0 ? void 0 : item.heading, "</h2>").concat(item === null || item === void 0 ? void 0 : item.content.map(function(contentItem) {
                            return contentItem === null || contentItem === void 0 ? void 0 : contentItem.markup;
                        }).join(""));
                    }).join("")
                });
            case "BlockFullWidth":
                return /*#__PURE__*/ React.createElement(FullWidth, {
                    key: index,
                    markup: block.content.map(function(item) {
                        return "".concat((item === null || item === void 0 ? void 0 : item.heading) ? "<h2>".concat(item.heading, "</h2>") : "").concat(item === null || item === void 0 ? void 0 : item.content.map(function(contentItem) {
                            return contentItem === null || contentItem === void 0 ? void 0 : contentItem.markup;
                        }).join(""));
                    }).join(""),
                    grayBackground: block.grayBackground,
                    boxedWidth: block.boxedWidth,
                    rawHtml: block.rawHtml
                });
            case "BlockTextWithMetrics":
                var _block_image, _block_content_filter_;
                var _block_embedLink;
                return /*#__PURE__*/ React.createElement(TextWithStat, {
                    key: index,
                    image: block.image ? decodeURI(JSON.parse(((_block_image = block.image) === null || _block_image === void 0 ? void 0 : _block_image.source) || "").src) : undefined,
                    embedLink: (_block_embedLink = block.embedLink) !== null && _block_embedLink !== void 0 ? _block_embedLink : undefined,
                    imagePosition: block.image ? "left" : undefined,
                    statistic: block.statistic
                }, (_block_content_filter_ = block.content.filter(// @ts-ignore
                function(childBlock) {
                    return typeof (childBlock === null || childBlock === void 0 ? void 0 : childBlock.metric) === "undefined";
                })[0]) === null || _block_content_filter_ === void 0 ? void 0 : _block_content_filter_.content.map(function(grandchildBlock) {
                    switch(grandchildBlock === null || grandchildBlock === void 0 ? void 0 : grandchildBlock.__typename){
                        // @ts-ignore
                        case "BlockQuote":
                            return(// @ts-ignore
                            /*#__PURE__*/ React.createElement(BlockQuote, grandchildBlock));
                        // @ts-ignore
                        case "BlockText":
                            return /*#__PURE__*/ React.createElement(Html, {
                                markup: grandchildBlock.markup
                            });
                    }
                }));
            case "BlockText":
                return /*#__PURE__*/ React.createElement("div", {
                    className: "page-container"
                }, /*#__PURE__*/ React.createElement(BlockText, _object_spread({
                    key: index
                }, block)));
            case "BlockTable":
                return /*#__PURE__*/ React.createElement("div", {
                    className: "page-container"
                }, /*#__PURE__*/ React.createElement(BlockTable, _object_spread({
                    key: index
                }, block)));
            case "AlertBox":
                return /*#__PURE__*/ React.createElement(AlertBox, _object_spread({
                    key: index
                }, block));
            case "ProcessTabs":
                return /*#__PURE__*/ React.createElement(ProcessTabs, _object_spread({
                    key: index
                }, block));
            case "SoftwareGraphic":
                return /*#__PURE__*/ React.createElement(SoftwareGraphic, _object_spread({
                    key: index
                }, block));
            case "BlockIntro":
                return /*#__PURE__*/ React.createElement(BlockIntro, _object_spread({
                    key: index
                }, block));
            case "MetricContent":
                return /*#__PURE__*/ React.createElement(MetricContent, _object_spread({
                    key: index
                }, block));
            case "CtaBanner":
                return /*#__PURE__*/ React.createElement(CtaBanner, _object_spread({
                    key: index
                }, block));
            case "CtaSlider":
                return /*#__PURE__*/ React.createElement(CtaSlider, _object_spread({
                    key: index
                }, block));
            case "TeaserGrid":
                return /*#__PURE__*/ React.createElement(TeaserGrid, _object_spread({
                    key: index
                }, block));
            case "FeaturedResources":
                return /*#__PURE__*/ React.createElement(FeaturedResources, _object_spread({
                    key: index
                }, block));
            case "BenefitsTabs":
                return /*#__PURE__*/ React.createElement(BenefitsTabs, _object_spread({
                    key: index
                }, block));
            case "TextImageBlock":
                return /*#__PURE__*/ React.createElement(TextImageBlock, _object_spread({
                    key: index
                }, block));
            case "CtaShape":
                return /*#__PURE__*/ React.createElement(CtaShape, _object_spread({
                    key: index
                }, block));
            case "ThreeColShape":
                //@ts-ignore
                return /*#__PURE__*/ React.createElement(ThreeColShape, _object_spread({
                    key: index
                }, block));
            case "FooterBanner":
                return /*#__PURE__*/ React.createElement(FooterBanner, block);
            case "LifecycleDiagram":
                return /*#__PURE__*/ React.createElement(LifecycleDiagram, _object_spread({
                    key: index
                }, block));
            case "CustomerSolutions":
                return /*#__PURE__*/ React.createElement(CustomerSolutions, _object_spread({
                    key: index
                }, block));
            case "CustomerCta":
                return /*#__PURE__*/ React.createElement(CustomerCta, _object_spread({
                    key: index
                }, block));
            case "TabbedInformation":
                return /*#__PURE__*/ React.createElement(TabbedInformation, _object_spread({
                    key: index
                }, block));
            case "PricingHeader":
                return /*#__PURE__*/ React.createElement(PricingHeader, _object_spread({
                    key: index
                }, block));
            case "PricingTable":
                return /*#__PURE__*/ React.createElement(PricingTable, _object_spread({
                    key: index
                }, block));
            case "TwoColIframe":
                return /*#__PURE__*/ React.createElement(TwoColIframe, _object_spread({
                    key: index
                }, block));
            case "Accordion":
                return /*#__PURE__*/ React.createElement(Accordion, _object_spread({
                    key: index
                }, block));
            case "BlockSolution":
                return /*#__PURE__*/ React.createElement(BlockSolution, _object_spread({
                    key: index
                }, block));
            case "FourColBlocks":
                return /*#__PURE__*/ React.createElement(FourColBlocks, _object_spread({
                    key: index
                }, block));
            case "AngleTeaserBlock":
                return /*#__PURE__*/ React.createElement(AngleTeaserBlock, _object_spread({
                    key: index
                }, block));
            case "EventSpeakers":
                return /*#__PURE__*/ React.createElement(EventSpeakers, _object_spread({
                    key: index
                }, block));
            case "PreviousVersions":
                return /*#__PURE__*/ React.createElement(PreviousVersions, _object_spread({
                    key: index
                }, block));
            case "TwoColVideo":
                return /*#__PURE__*/ React.createElement(TwoColVideo, _object_spread({
                    key: index
                }, block));
            case "TwoColMedia":
                return /*#__PURE__*/ React.createElement(TwoColMedia, _object_spread({
                    key: index
                }, block));
            case "TwoColInfo":
                return /*#__PURE__*/ React.createElement(TwoColInfo, _object_spread({
                    key: index
                }, block));
            case "DownloadsTable":
                return /*#__PURE__*/ React.createElement(DownloadsTable, _object_spread({
                    key: index
                }, block));
            case "PreviousDownloadsTable":
                return /*#__PURE__*/ React.createElement(PreviousDownloadsTable, _object_spread({
                    key: index
                }, block));
            case "TabbedContent":
                return /*#__PURE__*/ React.createElement(TabbedContent, _object_spread({
                    key: index
                }, block));
            case "LogosWithText":
                return /*#__PURE__*/ React.createElement(LogosWithText, {
                    key: index,
                    logosHeading: block.logosHeading,
                    logoItems: block.logoItems.filter(function(block) {
                        return block.image !== null;
                    })
                });
            case "AutoDownload":
                return /*#__PURE__*/ React.createElement("div", {
                    className: "page-container"
                }, /*#__PURE__*/ React.createElement(AutoDownload, _object_spread({
                    key: index
                }, block)));
            case "TwoColAngleBlock":
                return /*#__PURE__*/ React.createElement(TwoColAngleBlock, _object_spread({
                    key: index
                }, block));
            case "TwoColList":
                return /*#__PURE__*/ React.createElement(TwoColList, _object_spread({
                    key: index
                }, block));
            case "ContentWithImage":
                return /*#__PURE__*/ React.createElement(ContentWithImage, _object_spread({
                    key: index
                }, block));
            case "Slideshow":
                return /*#__PURE__*/ React.createElement(Slideshow, _object_spread({
                    key: index
                }, block));
            case "TeamTabs":
                return /*#__PURE__*/ React.createElement(TeamTabs, _object_spread({
                    key: index
                }, block));
            case "HubspotFormFullWidth":
                var _obj;
                return /*#__PURE__*/ React.createElement("div", {
                    className: "page-container mt-12"
                }, /*#__PURE__*/ React.createElement("div", {
                    style: block.preferredWidth === "narrow" && block.width ? {
                        width: "".concat(block.width, "%")
                    } : undefined,
                    className: clsx((_obj = {
                        "w-full": block.preferredWidth === "full"
                    }, _define_property(_obj, "w-[".concat(block.width, "px]"), block.preferredWidth === "narrow" && block.width), _define_property(_obj, "lg:w-2/3 px-6 md:px-0", block.preferredWidth !== "full" && block.preferredWidth !== "narrow"), _define_property(_obj, "lg:m-auto", block.alignment === "center" && block.preferredWidth !== "full"), _obj))
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "border border-black shadow-md rounded-xl bg-white p-6 md:p-9"
                }, (block === null || block === void 0 ? void 0 : block.formHeading) && /*#__PURE__*/ React.createElement("div", {
                    className: "text-lg max-[767px]:leading-snug md:text-xl xl:text-2xl text-center mb-6 font-heading max-[767px]:pt-4"
                }, /*#__PURE__*/ React.createElement("h3", {
                    className: "font-semibold"
                }, block.formHeading), /*#__PURE__*/ React.createElement("p", null, block.formSubheading)), /*#__PURE__*/ React.createElement(HubspotForm, _object_spread({
                    key: index
                }, block.form, block)))));
            case "Video":
                return /*#__PURE__*/ React.createElement("div", {
                    className: "page-container"
                }, /*#__PURE__*/ React.createElement(Video, _object_spread({
                    key: index
                }, block)));
            case "BlockQuote":
                var _block_logo, _block_logo1, _block_image1, _block_image2;
                return block.displayMode === "container" ? /*#__PURE__*/ React.createElement(FullQuote, {
                    key: index,
                    logo: ((_block_logo = block.logo) === null || _block_logo === void 0 ? void 0 : _block_logo.source) ? JSON.parse(((_block_logo1 = block.logo) === null || _block_logo1 === void 0 ? void 0 : _block_logo1.source) || "").src : undefined,
                    quote: (block === null || block === void 0 ? void 0 : block.text) || "",
                    source: (block === null || block === void 0 ? void 0 : block.author) || "",
                    role: (block === null || block === void 0 ? void 0 : block.role) || "",
                    company: (block === null || block === void 0 ? void 0 : block.company) || "",
                    image: ((_block_image1 = block.image) === null || _block_image1 === void 0 ? void 0 : _block_image1.source) ? JSON.parse(((_block_image2 = block.image) === null || _block_image2 === void 0 ? void 0 : _block_image2.source) || "").src : undefined
                }) : /*#__PURE__*/ React.createElement(BlockQuote, {
                    key: index,
                    text: (block === null || block === void 0 ? void 0 : block.text) || "",
                    author: (block === null || block === void 0 ? void 0 : block.author) || "",
                    role: (block === null || block === void 0 ? void 0 : block.role) || "",
                    company: (block === null || block === void 0 ? void 0 : block.company) || "",
                    displayMode: (block === null || block === void 0 ? void 0 : block.displayMode) || "",
                    displayImage: (block === null || block === void 0 ? void 0 : block.displayImage) || ""
                });
        }
    })));
}
